import React, { useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../../utils/utils";
import useMyobApi from "../../hooks/useMyobApi";
import useMixpanelEventAction from "../../config/mixpanel/useMixpanelEventAction";
import useGA4EventAction from "../../config/GoogleAnalytics/useGA4EventAction";
import { callBackComp, commonErrMsg, invcsConnect } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { INVOICE } from "../../route/paths";

const MyobCallBack = () => {
  const navigate = useNavigate();
  const initialRender = useRef(true);
  const { MyobCallBack } = useMyobApi();
  const { myobConnectMixpanelEvent } = useMixpanelEventAction();
  const { myobConnectGA4Event } = useGA4EventAction();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParams = queryParams.get("code");

  const handleMyobCallBack = useCallback(async () => {
    try {
      const response = await MyobCallBack({
        code: codeParams
      });

      await myobConnectGA4Event();
      if (!response.data.data.companyFiles) {
        myobConnectMixpanelEvent();
        showToast(commonErrMsg.myobSuccess, showToastType.success);
      }

      navigate(INVOICE, {
        state: {
          BookIdDetails: response.data.data.companyFiles
            ? response.data.data.companyFiles
            : null,
          softwareType: "MYOB",
          companyFiles: true
        }
      });

      if (!response.data.data.companyFiles) {
        showToast(commonErrMsg.myobSuccess, showToastType.success);
      }
    } catch (err) {
      console.error(invcsConnect.errMsg.item1, err);
      navigate(INVOICE);
      showToast(commonErrMsg.notFoundBook, showToastType.error);
    }
  }, [
    MyobCallBack,
    codeParams,
    navigate,
    myobConnectMixpanelEvent,
    myobConnectGA4Event
  ]);

  useEffect(() => {
    if (initialRender.current) {
      handleMyobCallBack();
      initialRender.current = false;
    }
  }, [handleMyobCallBack]);

  return <h5 className="text-dark">{callBackComp.doNotRefresh}</h5>;
};

export default MyobCallBack;
